import { useSyncProgress, useTriggerSync } from '@features/sync/hooks/useSyncProgress';
import { useAnalysisProgress, useTriggerAnalysis } from '@features/sync/hooks/useAnalysisProgress';
import { useTriggerReviewAnalysis } from '@features/sync/hooks/useReviewAnalysis';
import { SyncProgressBar } from '@features/sync/components/SyncProgressBar';
import { AnalysisProgressBar } from '@features/sync/components/AnalysisProgressBar';

export function SyncPanel() {
  const syncQuery = useSyncProgress();
  const analysisQuery = useAnalysisProgress();
  const triggerSync = useTriggerSync();
  const triggerAnalysis = useTriggerAnalysis();
  const triggerReviews = useTriggerReviewAnalysis();

  const syncRunning = syncQuery.data?.status === 'running' || syncQuery.data?.status === 'pending';
  const analysisRunning =
    analysisQuery.data?.status === 'running' || analysisQuery.data?.status === 'pending';

  return (
    <div className="space-y-4">
      <div className="flex gap-3">
        <button
          onClick={() => triggerSync.mutate()}
          disabled={syncRunning || triggerSync.isPending}
          className="btn btn-primary text-sm"
        >
          {syncRunning ? 'Syncing...' : 'Sync Catalog'}
        </button>
        <button
          onClick={() => triggerAnalysis.mutate()}
          disabled={analysisRunning || triggerAnalysis.isPending}
          className="btn btn-secondary text-sm"
        >
          {analysisRunning ? 'Analyzing...' : 'Run Analysis'}
        </button>
        <button
          onClick={() => triggerReviews.mutate()}
          disabled={triggerReviews.isPending}
          className="btn btn-outline text-sm"
        >
          {triggerReviews.isPending ? 'Starting...' : 'Analyze Reviews'}
        </button>
      </div>

      <SyncProgressBar data={syncQuery.data} isLoading={syncQuery.isLoading} />
      <AnalysisProgressBar data={analysisQuery.data} isLoading={analysisQuery.isLoading} />

      {triggerReviews.isSuccess && (
        <div className="text-sm text-green-600">Review analysis started.</div>
      )}
      {triggerReviews.error && (
        <div className="text-sm text-red-600">
          {triggerReviews.error instanceof Error
            ? triggerReviews.error.message
            : 'Failed to start review analysis'}
        </div>
      )}
    </div>
  );
}
